import React from 'react';
import cameraImg from './blog1.jpg';
import spotlightImg from './blog2.jpg';
import womanImg from './blog3.jpg';
import logoImg from './logo.png';
import ftrGradient from './footer-gradient.svg';
import leftArrow from './assets/images/left-arw.svg';
import tw from './assets/images/tw.svg';
import fb from './assets/images/fb.svg';
import yt from './assets/images/yt.svg';
import insta from './assets/images/insta.svg';
import linkedin from './assets/images/linkedin.svg';
import Buttons from './components/ui/Button/Button';
import supportImg from './support.png';
import profileImg from './assets/images/profile-ic.svg';
import emailImg from './assets/images/mail-ic.svg';
import phoneImg from './assets/images/phone-ic.svg';
import supporticonImg from './assets/images/support-ic.svg';
import maileditImg from './assets/images/message-ic.svg';
import ContactForm from './components/ContactForm';
import CtaSection from './components/CtaSection';

const newsData = [
  {
    title: 'Entertainment weekly',
    subtitle: 'Antoinette Abbamonte on Changing Hollywood from the Inside',
    author: 'Antoinette Abbamonte',
    date: 'April 15, 2022',
    image: cameraImg,
  },
  {
    title: 'Film Monthly',
    subtitle: 'Strength in Silence: A Groundbreaking Achievement in Cinema',
    author: 'Antoinette Abbamonte',
    date: 'May 02, 2025',
    image: spotlightImg,
  },
  {
    title: 'Geek Visual Media',
    subtitle:
      'How Since August Changed the Conversation on Inclusive Filmmaking',
    author: 'Antoinette Abbamonte',
    date: 'Mar 28, 2021',
    image: womanImg,
  },
];

const socialIcons = {
  Twitter: tw,
  Facebook: fb,
  YouTube: yt,
  Instagram: insta,
  Linkedin: linkedin,
};

const LastSection = () => {
  return (
    <div className="bg-[#421B03] text-white relative z-10">
      {/* PRESS/NEWS */}
      <div id="press" className="py-8 sm:py-16  px-5 sm:px-6 md:px-12">
        <div className="max-w-[1260px] mx-auto w-full relative ">
          {/* Decorative vertical lines */}
          <div className="absolute inset-0 z-0 flex justify-between none sm:flex pointer-events-none	">
            {[...Array(12)].map((_, i) => (
              <div key={i} className="w-[1px] bg-white h-full opacity-[0.03]" />
            ))}
          </div>
          <div className="flex justify-between items-center mb-4 md:mb-8 gap-4">
            <h2 className="lg:text-[40px] lg:leading-[120%] text-[24px] font-bold font-cinzel">
              Press/News
            </h2>
            {/* <Buttons label="Read All Blogs" /> */}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-[40px] lg:gap-8">
            {newsData.map((item, index) => (
              <div
                key={index}
                className="group rounded-xl flex flex-col h-full"
              >
                <div className="rounded-[30px] lg:h-[342px] w-full relative overflow-hidden transition-all duration-400 ease-ease-custom group-hover:translate-y-[-16px] flex items-end">
                  <a
                    href="/"
                    className="w-[120px] h-[120px] rounded-full flex items-center justify-center absolute z-10 top-2/4	left-2/4	translate-y-[-50%]	translate-x-[-50%] bg-[rgba(0, 0, 0, 0.16)] transition-all duration-400 ease-ease-custom border border-solid border-[rgba(255, 255, 255, .3)] backdrop-blur-[5px] text-[13px] font-ubuntu opacity-0 group-hover:opacity-100"
                  >
                    Read Blog
                  </a>
                  <div className="h-[120%] w-full relative overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className=" w-full h-full object-cover transition-all duration-400 ease-ease-custom  group-hover:translate-y-[44px] group-hover:grayscale-[1]"
                    />
                  </div>
                </div>
                <div className="flex flex-row justify-between items-center px-4 mt-[30px] transition-all duration-400 ease-ease-custom  group-hover:translate-y-[-16px]">
                  <div className="text-[#F2BA35] text-[24px] font-cinzel">
                    News
                  </div>
                  <div className="italic font-light font-ubuntu text-[16px] transition-all duration-400 ease-ease-custom">
                    {item.date}
                  </div>
                </div>
                <div className="px-4 pt-2 pb-4 flex flex-col flex-1 transition-all duration-400 ease-ease-custom group-hover:translate-y-[-16px]">
                  <h3 className="text-[24px] font-ubuntu font-bold mb-1">
                    {item.title}
                  </h3>
                  <p className=" font-light font-ubuntu text-[16px] text-white mb-2">
                    {item.subtitle}
                  </p>
                  <p className="italic font-light font-ubuntu text-xs mt-auto">
                    {item.author}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA SECTION */}
      <CtaSection />

      <ContactForm />
    </div>
  );
};

export default LastSection;
